export default __webpack_public_path__ + "static/logo-e29f471fac381fdccd56defb6c2937fe.svg";